import { colors } from 'theme/color-palette';
import fonts from 'constants/fonts';
import { PAGE_ID } from 'constants/tracker';
import { trackPageInfo } from './analytics';

export const BLOCKED_STATUS_CODE = 412;
export const CAPTCHA_HEADER_TXT = 'Before we continue...';
export const CAPTCHA_MESSAGE_TXT = 'Press & Hold to confirm you are a human (not a bot).';

export const getErrorCode = (response) => {
	if (response?.statusCode == BLOCKED_STATUS_CODE) {
		setPXProperties(response?.data);
		return BLOCKED_STATUS_CODE;
	} else return 505;
};

export const setPXProperties = (data) => {
	const { appId, jsClientSrc, firstPartyEnabled, vid, uuid, hostUrl, blockScript } = data;
	trackPageInfo(PAGE_ID.BOT_DETECTION);

	window._pxAppId = appId;
	window._pxJsClientSrc = jsClientSrc;
	window._pxFirstPartyEnabled = firstPartyEnabled;
	window._pxVid = vid;
	window._pxUuid = uuid;
	window._pxHostUrl = hostUrl;

	const script = document.createElement('script');
	script.src = blockScript;
	document.getElementsByTagName('head')[0].appendChild(script);

	window[`_${appId}`] = {
		challenge: {
			translation: {
				default: {
					btn: 'Press & Hold',
					btn_done: 'Done',
					failed: 'Please try again'
				}
			},
			view: {
				fillColor: colors.SNOMO_PURPLE,
				backgroundColor: colors.WHITE,
				borderColor: colors.SNOMO_PURPLE,
				borderRadius: 10,
				borderWidth: 1,
				textColor: colors.SNOMO_PURPLE,
				textSize: '16px',
				texSize: 16,
				width: '200px',
				height: '50px',
				targetColor: colors.WHITE,
				textFont: fonts.BOGLE_REGULAR
			},
			context: {
				headerText: CAPTCHA_HEADER_TXT,
				messageText: CAPTCHA_MESSAGE_TXT,
				headerColor: colors.DARK_CHARCOAL,
				messageColor: colors.DARK_CHARCOAL,
				messageFontSize: '16px',
				failed: {
					fontSize: '12px',
					color: colors.ERROR_RED_TEXT
				}
			}
		}
	};
};
